<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-17 17:33 -->
<!-- Description:  -->
<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>ID</th>
        <th>KEY</th>
        <th>VALUE</th>
        <th>DATATYPE</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(l1, i1) in list" :key="i1">
        <td>{{ l1.id }}</td>
        <td>{{ l1.key }}</td>
        <td>{{ l1.value }}</td>
        <td>{{ l1.data_type }}</td>
        <td>
          <button class="btn btn-light btn-sm" @click="preDelete(l1.id)"><i class="fas fa-trash"></i></button>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import {AdminService} from "../AdminService.js";

// script content
export default {
  name: "SettingTable",
  components: {
    //
  },

  // directives

  props: {
    list: {}
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async preDelete(id) {
      if(window.confirm("Eliminar este registro?")) {
        await AdminService.deleteSetting(id);
        this.$emit('itemDeleted');
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

